import { Injectable } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';

export const apiKeyHeaderName = 'X-Api-Key';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private token: string;

  public setToken(token: string) {
    this.token = token;
  }

  public getToken() {
    return this.token;
  }

  public buildOdataSource(url: string): DataSource {
    return new DataSource({
      store: new ODataStore({
        version: 4,
        url: url,
        beforeSend: (request: any) => {
          const token = this.token;
          if (token) {
            request.headers[apiKeyHeaderName] = token;
          }
        },
      }),
    });
  }
}
